import Paginate from 'vuejs-paginate'
import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import ProjectItem from './../ProjectItem/index.vue'
import Api from '../../../services/api'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Paginate,
    ProjectItem,
  },
  mounted() {},
  data() {
    return {
      projects: null,
      pageNumber: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: '',
      search: {
        text: '',
        type: 'all',
        numberPage: 1,
        countPages: 1,
        limit: 9,
        my: true,
      },
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.type = this.$route.query.type || 'all'
      this.search.numberPage = +this.$route.query.page || 1

      this.refreshDisplayProjects()
    },
  },
  methods: {
    changeTypeFilter(type) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          type: type,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },
    async refreshDisplayProjects() {
      try {
        this.$refs.progress.show()

        var response = await Api.getProjects(this.search)
        this.projects = response.data.results
        this.search.countPages = response.data.pagination.countPages

      } catch (error) {
        console.log("error")
        console.error(error)
        alert(error.message)
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.search.text = this.$route.query.text || ''
    this.search.type = this.$route.query.type || 'all'
    this.search.numberPage = +this.$route.query.page || 1

    this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/MyProjects/MyProjects.component.js